import { createSelector, createReducer } from '@reduxjs/toolkit';
import { HEARINGROLE_INCLUDE } from '../../constants/api';

import { updateDtoList } from '../helpers/reducerHelpers';
import {
  getIncludedData,
  getRequestData,
  selectAllFromApiState,
} from '../helpers/selectorHelpers';
import { getAttr } from '../helpers/apiHelpers';
import {
  getAllHearingRolesInitialize,
  getAllHearingRolesSuccess,
  getAllHearingsSuccess,
  getAllUsersSuccess,
  getHearingSuccess,
  getPaginatedHearingsSuccess,
} from '../actions/api';
import { all, call, fork, takeEvery } from '@redux-saga/core/effects';
import { generateGetAllApiCall } from '../helpers/sagaHelpers';
import { HearingRoleConnector } from '../connectors/hearingRoleConnector';

// -------- Overview --------
// The following endpoints exist
//  - GET /hearingRole
//
// HearingRole is included in the following endpoints
//  - GET /user
//  - GET /user/{id}
//  - GET /hearing
//  - GET /hearing/{id}

// -------- Reducer --------
const hearingRoleReducer = createReducer(
  {
    all: [],
  },
  (builder) => {
    builder
      .addCase(getAllHearingRolesSuccess, (state, action) => {
        const hearingRoles = getRequestData(action);
        return updateDtoList(state, 'all', hearingRoles);
      })
      .addCase(getAllUsersSuccess, (state, action) => {
        const data = getIncludedData(action);
        const hearingRoles = data.filter(
          (include) => include.type === HEARINGROLE_INCLUDE,
        );
        return updateDtoList(state, 'all', hearingRoles);
      })
      .addCase(getAllHearingsSuccess, (state, action) => {
        const data = getIncludedData(action);
        const hearingRoles = data.filter(
          (include) => include.type === HEARINGROLE_INCLUDE,
        );
        return updateDtoList(state, 'all', hearingRoles);
      })
      .addCase(getHearingSuccess, (state, action) => {
        const data = getIncludedData(action);
        const hearingRoles = data.filter(
          (include) => include.type === HEARINGROLE_INCLUDE,
        );
        return updateDtoList(state, 'all', hearingRoles);
      })
      .addCase(getPaginatedHearingsSuccess, (state, action) => {
        const data = getIncludedData(action);
        const hearingRoles = data.filter(
          (include) => include.type === HEARINGROLE_INCLUDE,
        );
        return updateDtoList(state, 'all', hearingRoles);
      });
  },
);

// --------- Sagas ------------
export function* hearingRoleSaga() {
  yield all([fork(getAllHearingRolesSaga)]);
}

function* getAllHearingRolesSaga() {
  yield takeEvery(
    getAllHearingRolesInitialize.type,
    generateGetAllApiCall(HearingRoleConnector, function* (connector) {
      return yield call([connector, connector.getHearingRoles]);
    }),
  );
}

// -------- Selectors --------
const selectGetAllHearingRoles = (state) =>
  selectAllFromApiState(state, 'hearingRole');
const allHearingRolesSelector = createSelector(
  selectGetAllHearingRoles,
  (hearingRoles) => hearingRoles,
);
const hearingRoleByRoleSelector = (role) =>
  createSelector(selectGetAllHearingRoles, (hearingRoles) =>
    hearingRoles.find((hr) => getAttr(hr, 'role') === role),
  );

// -------- Exporting --------
export { allHearingRolesSelector, hearingRoleByRoleSelector };
export default hearingRoleReducer;
